module.exports = __webpack_public_path__ + "images/icon_history_a07adc4bc5575f9d29d76cfd163d8a97.svg";